// extracted by mini-css-extract-plugin
module.exports = {"savedMessage":"MeetingNotes_savedMessage__Yyrdm","fadeOut":"MeetingNotes_fadeOut__3Hoi_","fadeIn":"MeetingNotes_fadeIn__3PW1p"};